module.exports = __webpack_public_path__ + "img/sand-4.84815662.png";